// Dates and other display formatting, shared by every page.

const D = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
const DT = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' });

/** "2027-03-10" (a DATE) → "10 Mar 2027". Parsed as a calendar date, never shifted by time zone. */
export function fmtDay(ymd) {
  if (!ymd) return '';
  const [y, m, d] = String(ymd).slice(0, 10).split('-').map(Number);
  return D.format(new Date(Date.UTC(y, m - 1, d, 12)));
}

export function fmtDateRange(start, end) {
  if (!start) return 'No dates set';
  if (!end || end === start) return fmtDay(start);
  return `${fmtDay(start)} – ${fmtDay(end)}`;
}

export const fmtDate = (v) => (v ? D.format(new Date(v)) : '—');
export const fmtDateTime = (v) => (v ? DT.format(new Date(v)) : '—');
